import React from 'react';
import feature2 from '../img/feature2.jpg';
import './PageCss/About.css';

const About = () => {
  return (
    <div id="about" className="about-section">
      <div className="about-container">
        <div className="about-header" data-aos="fade-up">
          <h2>About TechShara</h2>
          <p className="about-subtitle">
            Your partner in digital excellence
          </p>
        </div>

        <div className="about-content">
          <div className="about-image-container" data-aos="fade-right">
            <div className="tech-pattern"></div>
            <img 
              src={feature2}
              alt="About TechShara" 
              className="about-image"
            />
            <div className="floating-tech">
              <span>{"<Innovation/>"}</span>
              <span>{"{ Quality }"}</span>
              <span>{"[Excellence]"}</span>
              <span>{"# Growth"}</span>
            </div>
          </div>

          <div className="about-text" data-aos="fade-left">
            <h3>Who We Are</h3>
            <p>
              TechShara is your go-to platform for high-quality tech tutorials, professional online courses, and tailored IT solutions. 
              Our mission is to empower learners, developers, and businesses with the skills and services they need to thrive in the digital world. 
              Whether you're looking to master a new technology, build your career, or transform your business digitally — we're here to help.
            </p>
            <div className="tech-stack">
              <span>Learning</span>
              <span>Upskilling</span>
              <span>Consulting</span>
              <span>Development</span>
              <span>Support</span>
            </div>
          </div>
        </div>

        <div className="stats-container" data-aos="fade-up">
          <div className="stat-item">
            <h3>50+</h3>
            <p>Projects Delivered</p>
          </div>
          <div className="stat-item">
            <h3>10+</h3>
            <p>Happy Clients</p>
          </div>
          <div className="stat-item">
            <h3>1+</h3>
            <p>Years Experience</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
